import { PartnerEntryUserEventStatus } from "@/api/types";
import { SelectItem } from "@/components/Atoms/OccSelectbox/types";

export const allLotteryEventStatusMapping: {
  [key in PartnerEntryUserEventStatus]: string;
} = {
  invited: "特別案内",
  pre_entried: "レジュメ提出待ち",
  entried: "申込済（抽選中）",
  elected: "当選（参加予定）",
  defeated: "落選",
  absented: "欠席",
  attended: "出席済み",
  canceled: "キャンセル"
} as const;

export const allUnlotteryEventStatusMapping: {
  [key in PartnerEntryUserEventStatus]: string;
} = {
  invited: "特別案内",
  pre_entried: "レジュメ提出待ち",
  entried: "申込済",
  elected: "当選（参加予定）",
  defeated: "落選",
  absented: "欠席",
  attended: "出席済み",
  canceled: "キャンセル"
} as const;

export const unlotteryEventStatusSearchOptions: SelectItem<string>[] = [
  { label: "特別案内", value: "invited" },
  { label: "レジュメ提出待ち", value: "pre_entried" },
  { label: "申込済", value: "entried" },
  { label: "当選（参加予定）", value: "elected" },
  { label: "落選", value: "defeated" },
  { label: "欠席", value: "absented" },
  { label: "出席済み", value: "attended" },
  { label: "キャンセル", value: "canceled" }
];

export const lotteryEventStatusSearchOptions: SelectItem<string>[] = [
  { label: "特別案内", value: "invited" },
  { label: "レジュメ提出待ち", value: "pre_entried" },
  { label: "申込済（抽選中）", value: "entried" },
  { label: "当選（参加予定）", value: "elected" },
  { label: "落選", value: "defeated" },
  { label: "欠席", value: "absented" },
  { label: "出席済み", value: "attended" },
  { label: "キャンセル", value: "canceled" }
];

export const lotteryTransitionPossibleEventStatuses: {
  label: string;
  value: string;
}[] = [
  { label: "当選", value: "elected" },
  { label: "落選", value: "defeated" },
  { label: "出席", value: "attended" },
  { label: "欠席", value: "absented" }
];

export const unlotteryTransitionPossibleEventStatuses: {
  label: string;
  value: string;
}[] = [
  { label: "出席", value: "attended" },
  { label: "欠席", value: "absented" }
];

export const getDisplayEventStatus = (
  status: PartnerEntryUserEventStatus,
  lottery: boolean
): string => {
  return lottery
    ? allLotteryEventStatusMapping[status]
    : allUnlotteryEventStatusMapping[status];
};

export const getDisplayEventType = (type: string) => {
  switch (type) {
    case "seminar":
      return "説明会";
    case "internship":
      return "インターン";
    case "entry":
      return "本選考";
  }
};

export const selectListGenerator = (
  list: string[],
  labelMapping?: { [key: string]: string }
) => {
  return list.map(v => {
    const label = labelMapping ? labelMapping[v] : v;
    return {
      value: v,
      label: label
    };
  });
};
